import React, { useState } from 'react';
import { Dialog, Box, Typography } from '@mui/material';
import './DeleteAvailabilityModel.css';
import DeleteIcon from '../../../assets/ScheduleIcon/delete.svg';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { axiosInstance } from '../../../utils/tokenUtils';
import { toast } from 'react-hot-toast';

// Level mapping for display
const levelMapping = {
  high_school: 'High School',
  middle_school: 'Middle School',
  college_level: 'University',
  beginner: 'Beginner',
  intermediate: 'Intermediate',
  professional: 'Professional',
  All: 'All Level',
  'All Level': 'All Level',
};

const DeleteAvailabilityModel = ({ open, handleClose, session, onDelete }) => {
  const [isDeleting, setIsDeleting] = useState(false);

  // Function to handle deletion confirmation
  const handleConfirmDelete = async () => {
    if (!session || !session.sessionData || !session.sessionData.id) {
      toast.error('Unable to delete: Session ID not found');
      handleClose();
      return;
    }

    setIsDeleting(true);

    try {
      let response;

      // Check if this is a paused availability or regular availability
      if (
        session.type === 'Paused Sessions' ||
        session.sessionData.session_type === 'smart_pause'
      ) {
        // Use the pause-availability endpoint for paused sessions
        response = await axiosInstance.delete(
          `/teachers/pause-availability/${session.sessionData.id}`
        );
      } else {
        // Use the availability endpoint for regular sessions (one-on-one, group, prime)
        response = await axiosInstance.delete(`/teachers/availability/${session.sessionData.id}`);
      }

      console.log('Delete response:', response);

      // Show success toast
      toast.success('Availability schedule removed successfully');

      // Call the onDelete function if provided
      if (onDelete && session) {
        onDelete(session);
      }

      // Refresh calendar data
      if (window.refreshCalendarData) {
        window.refreshCalendarData();
      }
    } catch (error) {
      console.error('Error deleting availability:', error);
      toast.error(error.response?.data?.detail || 'Failed to delete availability');
    } finally {
      setIsDeleting(false);
      // Close the modal
      handleClose();
    }
  };

  // Format the session details for display
  const getSessionDetails = () => {
    if (!session) return { type: '', subject: 'all', level: 'all' };

    let sessionType = session.type || 'Session';
    // Format session type (e.g., "one_on_one" -> "One On One Session")
    if (sessionType === 'one_on_one') {
      sessionType = 'One On One Session';
    } else if (sessionType === 'group') {
      sessionType = 'Group Session';
    } else if (sessionType === 'prime') {
      sessionType = 'Prime Session';
    }

    const subject = session.subject || 'all';
    const level = session.level || 'all';

    return { sessionType, subject, level };
  };

  const { sessionType, subject, level } = getSessionDetails();

  if (!open) return null;

  return (
    <div className="modal-overlay">
      <div className="modal confirmation-modal-delete">
        <div className="confirmation-content">
          <div className="info-icon-container">
            <img src={DeleteIcon} alt="Delete" className="info-icon" />
          </div>
          <Typography className="delete-availability-text">Delete Availability</Typography>
          <p className="confirmation-text">
            Are you sure you want to delete this {sessionType} availability?
          </p>
          <p className="delete-warning">This action cannot be undone.</p>
          <div className="confirmation-buttons">
            <button className="dismiss-button" onClick={handleClose} disabled={isDeleting}>
              Cancel
            </button>
            <button className="delete-button" onClick={handleConfirmDelete} disabled={isDeleting}>
              {isDeleting ? 'DELETING...' : 'DELETE'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteAvailabilityModel;
